"use strict";

exports.__esModule = true;
var _AboutScreen = require("./AboutScreen");
Object.keys(_AboutScreen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AboutScreen[key]) return;
  exports[key] = _AboutScreen[key];
});